<template>
  <div class="Panel">
    <div class="tip"><span>{{tip}}</span></div>
    <el-card shadow="never" class="P-Login">
      <div class="G-Title"><i class="el-icon-user-solid"></i><span>用户登录</span></div>
      <div>
        <el-form @keypress.enter.native="submitForm('ruleForm')" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="AuthForm">
          <el-form-item prop="username" class="form-group">
            <el-input type="username" v-model.trim="ruleForm.username" autocomplete="off" placeholder="请输入用户名或邮箱" ></el-input>
          </el-form-item>
          <el-form-item prop="password" style="padding-bottom: 4px">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <div style="text-align: right">
              <router-link to="forget" class="link" >忘记密码？</router-link>
            </div>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading" style="width: 100%; margin-top: 4px">登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="my-3">您还不是一楼一凤会员？</div>
      <router-link to="registered" class="link"><el-button round plain style="margin-bottom: 10px">立即注册</el-button></router-link>
    </el-card>
  </div>
</template>

<script>
import {request} from '../../network/request'

export default {
  name: 'login',
  mounted () {
    request({
      url: '/api/tip',
      method: 'post'
    }).then(res => {
      this.tip = res.data.tip
    }).catch(err => {
      this.$message.error('网络出错')
      this.tip = err
    })
  },
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6 || value.length > 32 || /[\u4E00-\u9FA5]/g.test(value)) {
        callback(new Error('密码 必须介于 6 - 32 个字符之间。'))
      } else {
        callback()
      }
    }
    let validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
      // } else if (value.length < 2 || value.length > 20 || !this.checkSpecialKey(value)) {
      //   callback(new Error('名称 必须介于 2 - 20 个字符之间。'))
      // }
    }
    return {
      tip: '...',
      loading: false,
      PageLoading: true,
      ruleForm: {
        password: '',
        username: ''
      },
      rules: {
        password: [
          {validator: validatePass, trigger: 'blur'}
        ],
        username: [
          {validator: validateName, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    checkSpecialKey (str) {
      var specialKey = "[`~!#@$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
          return false
        }
      }
      return true
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = new URLSearchParams()
          data.append('username', this.ruleForm.username)
          data.append('password', this.ruleForm.password)
          request({
            url: '/api/login',
            method: 'post',
            data: data
          })
            .then(function (res) {
              if (res.data['status'] === 0) {
                this.$message.success('登录成功')
                // 写入localStorage 以及 全局仓库
                localStorage.setItem('Flag', 'isLogin')
                this.$store.commit('Flag', localStorage.getItem('Flag'))
                this.$store.commit('proxy', false)
                if (res.data['promote'] === true) {
                  localStorage.setItem('promote', 'promote')
                  this.$store.commit('promote', localStorage.getItem('promote'))
                }
                // 返回上一层网页
                this.$router.go(-1)
              } else if (res.data['status'] === 2) {
                this.$message.success('登录成功')
                // 写入localStorage 以及 全局仓库
                localStorage.setItem('Flag', 'isLogin')
                this.$store.commit('Flag', localStorage.getItem('Flag'))
                localStorage.setItem('proxy', 'proxy')
                this.$store.commit('proxy', localStorage.getItem('proxy'))
                // 返回上一层网页
                this.$router.go(-1)
              } else {
                this.$message.error(res.data['msg'])
                this.loading = false
              }
            }.bind(this))
            .catch(function (error) {
              this.loading = false
              console.log(error)
            }.bind(this))
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .P-Login {
    max-width: 500px;
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .AuthForm {
    max-width: 320px;
    margin: 0 auto;
  }

  .form-group {
    margin-bottom: 3rem !important;
    margin-top: 3rem !important;
  }

  .G-Title {
    border-bottom: 1px solid #f2f2f2 !important;
    text-align: left;
  }

  .tip {
    font-size: 18px;
    text-align: center !important;
    margin-bottom: 24px !important;
    margin-top: 14px !important;
    color: #999 !important;
    height: 27px;
  }

  .my-3 {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
    font-size: 14px;
  }
  .Panel{
    padding-bottom: 3rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue